import { money } from "@getaways/extranet-ui";

/** EUR from minor units, no cents: reports read in whole euros. "—" when unknown or hidden by the role. */
export const eur = (minor: number | null | undefined) => (minor === null || minor === undefined ? "—" : money(minor, "EUR", { decimals: false }));

export const pct = (part: number | null | undefined, whole: number | null | undefined) => (part === null || part === undefined || !whole ? "—" : `${((part / whole) * 100).toFixed(1)}%`);

export const int = (n: number | null | undefined) => (n === null || n === undefined ? "—" : new Intl.NumberFormat("en-GB").format(n));

export const BRANDS: Record<string, string> = { "azores-getaways": "Azores Getaways", "portugal-getaways": "Portugal Getaways", "yes-getaways": "Yes Getaways" };

export const VERTICALS: Record<string, string> = { hotel: "Hotels", flight: "Flights", rail: "Rail", experience: "Experiences", activity: "Activities", transfer: "Transfers", car: "Cars", cruise: "Cruises", package: "Packages", insurance: "Insurance", other: "Other" };

export const STATUS: Record<string, string> = {
  pricing: "Pricing", awaiting_payment: "Awaiting payment", awaiting_approval: "Awaiting approval", booking: "Booking", confirmed: "Confirmed", price_changed: "Price changed",
  unavailable: "Unavailable", rejected: "Rejected", expired: "Expired", cancelled: "Cancelled", failed: "Failed", needs_attention: "Needs attention",
};
